import qs from 'qs'
import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinDocument = {
  async apiDefaultFileById(
    arg = {
      method: {},
      params: {},
    }
  ) {
    // let [err, res] = [null, null]
    const [err, res] = await To(
      wizStandardInstance.get(`/file/getfilecontentasync/${arg.params.id || ' '}`)
    )
    return Callback.globalCBForOld(err, res, arg.extra)
  },
  async apiImportExportDocs(
    arg = {
      method: '',
      params: {},
      ids: [],
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'exportDocClassTemplate':
        ;[err, res] = await To(
          wizStandardInstance.get('/api/DocumentClass/GetEmptyExcelTemplateAsync')
        )
        break
      case 'exportDocTemplate':
        ;[err, res] = await To(wizStandardInstance.get('/api/Document/GetEmptyExcelTemplateAsync'))
        break
      case 'ExportDocClassById':
        // TODO need double check why here used post and post what
        ;[err, res] = await To(
          wizStandardInstance.post('/api/DocumentClass/handover/ExportByIdAsync', arg.ids)
        )
        break
      case 'exportDocumentClassExcel':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/DocumentClass/handover/ExportAsync/${arg.params.parentId || ' '}/${arg.params
                .keywords || ' '}/${arg.params.OrderBy || ' '}?isIncludeParent=${arg.params
                .isIncludeParent || false}`
            )
          )
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiDocumentClass(
    arg = {
      method: '',
      params: {},
      formData: {},
      ids: [],
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'comboxTree':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/DocumentClass/GetComboxTreeAsync/${arg.params.documentClassId || ' '}/${arg
                .params.keywords || ' '}`
            )
          )
        )
        break
      case 'uploadDocClass':
        ;[err, res] = await To(
          wizStandardInstance.post(
            `/api/DocumentClass/UploadExcelAsync/${arg.params.id || ' '}`,
            arg.formData
          )
        )
        break
      case 'updateDocumentClass':
        const obj = {
          fileId: ' ',
          pageNo: 1,
          pageSize: 10,
          keyWord: ' ',
        }
        if (arg.params) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Document/UpdateDocumentClass/${obj.folderId}/${obj.documentClassId}/${obj.isUpdateChild}/${obj.isOnlyUpdateEmptyData}`
            )
          )
        )
        break
      case 'getTAll':
        const getTAllObj = {
          parentId: ' ',
          pageNo: 1,
          pageSize: 10,
          orderby: ' ',
          isAsc: '',
          keywords: ' ',
          isIncludeParent: false,
        }
        if (arg.params) {
          _.assign(getTAllObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/DocumentClass/GetAllAsync/${getTAllObj.parentId}/${getTAllObj.pageNo}/${getTAllObj.pageSize}/${getTAllObj.orderby}/${getTAllObj.isAsc}/${getTAllObj.keywords}?isIncludeParent=${getTAllObj.isIncludeParent}`
          )
        )
        break
      case 'docIconList':
        ;[err, res] = await To(wizStandardInstance.get('/iconfile/dociconlist'))
        break
      case 'getDoc':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/DocumentClass/GetAsync/${arg.params.id}`)
        )
        break
      case 'getDocRelation':
        const getDocRelationObj = {
          siteId: ' ',
          classId: ' ',
          pageNo: 1,
          pageSize: 10,
        }
        if (arg.params) {
          _.assign(getDocRelationObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/DocumentClass/GetDocumentAsync/${getDocRelationObj.siteId}/${getDocRelationObj.classId}/${getDocRelationObj.pageNo}/${getDocRelationObj.pageSize}`
          )
        )
        break
      case 'updateDocClass':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/DocumentClass/UpdateAsync', arg.params)
        )
        break
      case 'addDocClass':
        ;[err, res] = await To(wizStandardInstance.post('/api/DocumentClass/AddAsync', arg.params))
        break
      case 'delDocClass':
        ;[err, res] = await To(wizStandardInstance.post('/api/DocumentClass/DeleteAsync', arg.ids))
        break
      case 'delDocRelation':
        ;[err, res] = await To(
          wizStandardInstance.post(`/api/Document/DeleteDocumentRelationAsync/${arg.params.id}`)
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiFolder(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'addFolder':
        ;[err, res] = await To(wizStandardInstance.post('/api/folder/addlistasync', arg.params))
        break
      case 'folderDetail':
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/folder/getasync/${arg.params.folderId}`))
        )
        break
      case 'folderList':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/folder/gettreesingleasync/${arg.params.siteId || ' '}/${arg.params.parentId ||
                ' '}`
            )
          )
        )
        break
      case 'updateFolder':
        ;[err, res] = await To(wizStandardInstance.post('/api/folder/updateasync', arg.params))
        break
      case 'deleteFolder':
        ;[err, res] = await To(wizStandardInstance.post('/api/folder/DeleteAsync', arg.params.ids))
        break
      case 'queryFolder':
        ;[err, res] = await To(wizStandardInstance.post('/api/folder/query_main', arg.params))
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiDocumentFile(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'deleteFile':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/DocumentFile/DeleteAsync/', arg.params.fileIds)
        )
        break
      case 'tagsByDocFileId':
        const obj = {
          fileId: ' ',
          pageNo: 1,
          pageSize: 8,
          keyWord: ' ',
        }
        if (arg.params) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/DocumentFile/GetTagsAsync/${obj.fileId}/${obj.pageNo}/${obj.pageSize}/${obj.keyWord}`
            )
          )
        )
        break
      case 'intelligenceDocument':
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(
              `/api/DocumentFile/IntelligenceDocumentAsync/${arg.params.siteId}/${arg.params
                .documentId || ' '}`
            )
          )
        )
        break
      case 'IntelligenceFile':
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(`/api/DocumentFile/IntelligenceFileAsync/${arg.params.siteId}`),
            arg.params.fileIds || []
          )
        )
        break
      case 'RelieveDisassociate':
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(`/api/DocumentFile/RelieveDisassociateAsync/${arg.params.tagFileAssoId}`)
          )
        )
        break
      case 'TagTreeByKeywords':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/DocumentFile/GetTagTreeByKeywordsAsync/${arg.params.siteId || ' '}/${arg.params
                .fileId || ' '}/${arg.params.keyWord || ' '}`
            )
          )
        )
        break
      case 'IntelligenceFileTag':
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(
              `/api/DocumentFile/intelligencefiletagasync/${arg.params.fileId || ' '}/${arg.params
                .tagId || ' '}/${arg.params.alias || ' '}`
            )
          )
        )
        break
      case 'query':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/DocumentFile/query_files', arg.params)
        )
        break
      case 'addDocumentFile':
        ;[err, res] = await To(wizStandardInstance.post('/api/DocumentFile/main', arg.params))
        break
      case 'updateDocumentFile':
        ;[err, res] = await To(wizStandardInstance.patch('/api/DocumentFile/main', arg.params))
        break
      case 'queryDocumentFile':
        ;[err, res] = await To(wizStandardInstance.post('/api/DocumentFile/query_main', arg.params))
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiDocuments(
    arg = {
      method: {
        list,
      },
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'baseDocument':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/basedata/document?${qs.stringify(arg.params)}`)
        )
        break
      case 'baseDocumentFile':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/basedata/documentfile?${qs.stringify(arg.params)}`)
        )
        break
      case 'baseDocumentModel':
        ;[err, res] = await To(wizStandardInstance.get('/api/std/Document/pr-file-all'))
        break
      case '3dModels':
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/Document/3d_models/${arg.params.siteId}`))
        )
        break
      case 'FoldersBriefList':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/Document/GetFoldersBriefListAsync/''/${arg.params.documentId || ' '}`)
          )
        )
        break
      case 'excelTemplate':
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(
              `/api/Document/GetExcelTemplateAsync/${arg.params.siteId || ' '}/${arg.params
                .keyWord || ' '}`
            ),
            arg.params.documentIds || []
          )
        )
        break
      case 'docAttrById':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/Document/GetDocumentAttrAsync/${arg.params.id || ' '}`)
          )
        )
        break
      case 'correlateTagByDocumentId':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/Document/GetFileCorrelateTagsAsync/${arg.params.id || ' '}`)
          )
        )
        break
      case 'filesByDocumentId':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/Document/GetFileListAsync/${arg.params.documentId || ' '}`)
          )
        )
        break
      case 'uploadDoc':
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(`/api/Document/UploadExcelAsync/${arg.params.id || ' '}`),
            arg.formData
          )
        )
        break
      case 'addDocument':
        ;[err, res] = await To(wizStandardInstance.post('/api/document/AddAsync', arg.params))
        break
      case 'updateDoc':
        ;[err, res] = await To(wizStandardInstance.post('/api/Document/UpdateAsync', arg.params))
        break
      case 'deleteDoc':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Document/DeleteAsync', arg.params.ids)
        )
        break
      case 'queryDoc':
        ;[err, res] = await To(wizStandardInstance.post('/api/Document/query_main', arg.params))
        break
      case 'docModelsById':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/Document/GetModelDetailAsync/${arg.params.id || ' '}`)
          )
        )
        break
      case 'deleteDocModelById':
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(`/api/Document/DeleteModelAsync/${arg.params.id || ' '}`)
          )
        )
        break
      case 'docDetailById':
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/std/Document/${arg.params.id || ' '}`))
        )
        break
      case 'docListByFolderId':
        const listObj = {
          siteId: ' ',
          folderId: ' ',
          pageNo: 1,
          pageSize: 10,
          orderby: 'lastModifiedTime',
          isAsc: true,
          keyWord: ' ',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Document/GetDocumentListAsync/${listObj.siteId}/${listObj.folderId}/${listObj.pageNo}/${listObj.pageSize}/${listObj.orderby}/${listObj.isAsc}/${listObj.keyWord}`
            )
          )
        )
        break
      case 'models':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/Document/models/?isTemp=${arg.params.isTemp}&siteId=${arg.params.siteId}`
          )
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiExportPdf(
    arg = {
      serverUrl: currentEnv.File_Web,
      method: {},
      params: {},
    }
  ) {
    const [err, res] = await To(
      wizStandardInstance.post(`${arg.serverUrl}/api/document/build_qrcode`, arg.params)
    )
    return Callback.globalCBForOld(err, res, arg.extra)
  },
}
export default {
  methods: ApiMixinDocument,
}
